<template>
  <div class="field">
    <div class="control">
      <label>
        <input
          v-model.trim="var_name"
          class="input is-large"
          :size="size"
          :maxlength="maxlength"
          type="text"
          :name="id"
          :placeholder="placeholder"
          :disabled="isDisabled"
          @input="$emit('update:modelValue', $event.target.value)"
      /></label>
    </div>
  </div>
</template>
<script setup>
import { ref } from 'vue';
defineOptions({
  name: 'InputField'
});
const props = defineProps({
  placeholder: {
    type: String,
    required: true
  },
  defaultValue: {
    type: String,
    required: true
  },
  id: {
    type: String,
    default: ''
  },
  ariaLabel: {
    type: String,
    default: ''
  },
  size: {
    type: Number,
    default: 20
  },
  maxlength: {
    type: Number,
    default: 20
  },
  isDisabled: {
    type: Boolean,
    default: false
  }
});

defineEmits(['update:modelValue']);
const var_name = ref(props.defaultValue);
</script>
<style></style>
